/**
 * Tipos y reads puros de Caja — seguros para reports (sin cycle).
 * No incluir: resolveCashSummary, cashSessionsRepo open/close, cashSummaryRemoteCache
 * (esos tiran reports o sync).
 */
export type { CashSessionRow } from './infra/cashSessionRow';
export type { CashSummary } from './infra/cashSummaryTypes';
export type { CashDifferenceRow, CashSessionDetail } from './infra/cashSummaryQuery';
export {
  getCashSummary,
  getCashSessionDetail,
  countCashSessionsHistory,
  getCashSessionsHistory,
} from './infra/cashSummaryQuery';
export { buildCashSessionPaymentBreakdown } from './infra/cashSummaryBreakdown';
export type { CashOutflowCategory } from './infra/cashOutflowCategories';
export {
  CASH_OUTFLOW_CATEGORIES,
  CASH_OUTFLOW_CATEGORY_LABELS,
  CASH_MOVEMENT_CATEGORY_LABELS,
  isCashMovementCategory,
} from './infra/cashOutflowCategories';
export { CASH_DIFFERENCES_PAGE_SIZE } from './infra/cashDifferencesConstants';
